import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

@inject('appStore')
@observer
export default class ReportsView extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="tab-pane active">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 fill">Reports</div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/reports/report-view.js